import React from 'react';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { ROLE_COLORS } from './adminConstants';

export const AdminUserDialog = ({ selectedUser, currentUser, editRole, setEditRole, onClose, onSave }) => (
  <Dialog open={!!selectedUser} onOpenChange={onClose}>
    <DialogContent style={{ background: '#fff', border: '1px solid #ECE7DE', borderRadius: 14, maxWidth: 480 }}>
      <DialogHeader>
        <DialogTitle style={{ fontFamily: 'Cabinet Grotesk' }}>User Details</DialogTitle>
      </DialogHeader>
      {selectedUser && (
        <div>
          <div style={{ padding: '1rem', borderRadius: 10, background: '#F1EAE1', border: '1px solid #ECE7DE', marginBottom: '1.25rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.75rem' }}>
              <div style={{ width: 48, height: 48, borderRadius: '50%', background: `linear-gradient(135deg, ${ROLE_COLORS[selectedUser.role] || '#0076A3'}, ${ROLE_COLORS[selectedUser.role] || '#0076A3'}80)`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1rem', fontWeight: 700, color: '#fff' }}>
                {selectedUser.name?.charAt(0)?.toUpperCase()}
              </div>
              <div>
                <div style={{ fontSize: '1rem', fontWeight: 700, color: '#0076A3' }}>{selectedUser.name}</div>
                <div style={{ fontSize: '0.8125rem', color: '#64748B' }}>{selectedUser.email}</div>
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem', fontSize: '0.8125rem' }}>
              <div><span style={{ color: '#94A3B8' }}>First Name:</span> <span style={{ color: '#0076A3', fontWeight: 500 }}>{selectedUser.first_name || '—'}</span></div>
              <div><span style={{ color: '#94A3B8' }}>Last Name:</span> <span style={{ color: '#0076A3', fontWeight: 500 }}>{selectedUser.last_name || '—'}</span></div>
              <div><span style={{ color: '#94A3B8' }}>Location:</span> <span style={{ color: '#0076A3', fontWeight: 500 }}>{selectedUser.location || '—'}</span></div>
              <div><span style={{ color: '#94A3B8' }}>Role:</span> <Badge style={{ background: `${ROLE_COLORS[selectedUser.role] || '#64748B'}15`, color: ROLE_COLORS[selectedUser.role] || '#64748B', borderRadius: 999, fontSize: '0.625rem', border: 'none', textTransform: 'capitalize', marginLeft: 4 }}>{selectedUser.role?.replace('_', ' ')}</Badge></div>
              <div><span style={{ color: '#94A3B8' }}>Joined:</span> <span style={{ color: '#0076A3', fontWeight: 500 }}>{selectedUser.created_at ? new Date(selectedUser.created_at).toLocaleDateString() : '—'}</span></div>
              {selectedUser.google_id && <div><span style={{ color: '#94A3B8' }}>Google:</span> <span style={{ color: '#059669', fontWeight: 500 }}>Linked</span></div>}
            </div>
          </div>

          {!selectedUser.is_super_admin && (
            <div style={{ marginBottom: '1rem' }}>
              <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 600, color: '#64748B', marginBottom: '0.375rem' }}>Change Role</label>
              <select value={editRole} onChange={e => setEditRole(e.target.value)} style={{ width: '100%', padding: '0.625rem 0.875rem', borderRadius: 8, border: '1px solid #CBD5E1', background: '#FAF7F2', color: '#0076A3', fontSize: '0.875rem', outline: 'none' }}>
                <option value="candidate">Candidate</option>
                <option value="recruiter">Recruiter</option>
                {currentUser?.role === 'super_admin' && <option value="admin">Admin</option>}
              </select>
            </div>
          )}
          {selectedUser.is_super_admin && (
            <div style={{ padding: '0.75rem', borderRadius: 8, background: '#FEF2F2', border: '1px solid #FECACA', fontSize: '0.75rem', color: '#DC2626', marginBottom: '1rem' }}>
              Super Admin account cannot be modified or deleted.
            </div>
          )}
        </div>
      )}
      <DialogFooter>
        <Button variant="outline" onClick={onClose} style={{ borderRadius: 10 }}>Close</Button>
        {selectedUser && !selectedUser.is_super_admin && (
          <Button onClick={onSave} style={{ background: '#0076A3', color: '#fff', borderRadius: 999, fontWeight: 600 }}>Save Changes</Button>
        )}
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
